import React from 'react';
import notFoundIcon from '@assets/icons/not-found.png';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface Props {
  message?: string;
}

const ErrorFallback: React.FC<Props> = ({ message }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div
        className="inline-flex flex-col items-center justify-center py-[70px] px-[258px] text-center rounded-[38px] max-lg-xl:py-12 max-lg-xl:px-[126px]"
        style={{
          background:
            'linear-gradient(180deg, rgba(255, 255, 255, 0) -114.92%, #D5E4FF 300.14%)'
        }}
      >
        <p className="text-[49px] font-semibold mb-3.5 max-lg-xl:text-[36px]">
          {message || t('error_boundary_title')}
        </p>

        <p className="text-[30px] font-medium text-[var(--blue-4)] opacity-40 max-lg-xl:text-[24px]">
          {t('error_boundary_desc')}
        </p>

        <img
          src={notFoundIcon}
          alt="Error"
          className="mt-16 max-lg-xl:w-[400px] max-lg-xl:mt-12"
        />

        <div className="flex items-center gap-8 mt-28 max-lg-xl:mt-20">
          <Button variant="outlined" onClick={() => navigate('/contact-us')}>
            {t('contact_us')}
          </Button>

          <Button variant="contained" onClick={() => window.location.reload()}>
            {t('reload')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
